import { forwardRef } from "react";
const SvgSortUpArrow = ({
  title,
  titleId,
  ...props
}, ref) => <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path d="M5.33331 4.66667L7.99998 2M7.99998 2L10.6666 4.66667M7.99998 2V14" stroke="#6C738C" strokeWidth={1.33333} strokeLinecap="round" strokeLinejoin="round" /></svg>;
const ForwardRef = forwardRef(SvgSortUpArrow);
export default ForwardRef;